(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(441);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _path_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/views/LazyViews.tsx

var pages = {
    "home.HomePage": dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 470).then(__webpack_require__.bind(__webpack_require__, 7470));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(7470)
                ];
            }
        }
    }),
    "flex.FlexPage": dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 739).then(__webpack_require__.bind(__webpack_require__, 2739));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(2739)
                ];
            }
        }
    }),
    "forms.FormPage": dynamic_default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(866), __webpack_require__.e(409), __webpack_require__.e(703), __webpack_require__.e(232)]).then(__webpack_require__.bind(__webpack_require__, 6232));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(6232)
                ];
            }
        }
    }),
    "pages.KursTypPage": dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 613).then(__webpack_require__.bind(__webpack_require__, 1613));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(1613)
                ];
            }
        }
    }),
    PasswordProtectedPage: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 704).then(__webpack_require__.bind(__webpack_require__, 5704));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(5704)
                ];
            }
        }
    })
};
/* harmony default export */ var LazyViews = (pages);

;// CONCATENATED MODULE: ./src/pages/[...path].tsx



function CatchAllPage(props) {
    var pageData = props.pageData;
    var Component = LazyViews[pageData.meta.type];
    if (!Component) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
            children: [
                "Component ",
                pageData.meta.type,
                " not found"
            ]
        });
    }
    // TODO: Fix Typing
    // @ts-ignore
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageData));
}
var __N_SSG = true;
/* harmony default export */ var _path_ = (CatchAllPage);


/***/ }),

/***/ 441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _path___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3987);

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (_path___WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);